import { ERROR_CODES } from '@/shared/errors/errorCodes'

export const POLICY_CASES = {
  BY_EXTERNAL_LINK: 'Policy not found by external link', // case 1
  ALREADY_RENEWED: 2, // case 2
  IS_ACTIVE: 3, // case 3
  WILL_BE_ACTIVE: 1, // case 4
  NO_RENEWAL_ALLOWED: 'noRenewalAllowed', // case 5
  // case 6
  // case 7
  UNPAID_INSTALLMENT: '1002',
  PAYMENT_LINK: ERROR_CODES.ACTIVE_PAYMENT_LINK_AVAILABLE
}
